import { render, staticRenderFns } from "./_CreateOrEdit.vue?vue&type=template&id=6f7c095b&scoped=true&"
import script from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./_CreateOrEdit.vue?vue&type=style&index=0&id=6f7c095b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c095b",
  null
  
)

export default component.exports